import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import Categories from "./components/Categories";
import Feed from "./components/Feed";
import BrandBand from "./components/BrandBand";
import Faqs from "./components/Faqs";
import useSeo from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "今日曝瓜 - 吃瓜群众聚集地 | 热点讨论与围观现场",
    description:
      "今日曝瓜是吃瓜群众聚集地，聚合热点事件围观、评论区瓜友热议、话题分类与意见投稿。在这里围观现场、理性吃瓜、看透每一个热点事件。",
  });

  return (
    <div className="flex min-h-screen flex-col bg-cream-50">
      <Navbar />
      <main>
        <Hero />
        <HotBoard />
        <Categories />
        <Feed />

        {/* CTA 横幅 */}
        <section className="mx-auto w-full max-w-7xl px-4 py-6 md:px-6">
          <div className="flex flex-col items-start justify-between gap-5 overflow-hidden rounded-3xl bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-8 text-white md:flex-row md:items-center md:px-10">
            <div className="flex items-center gap-4">
              <span className="hidden h-14 w-14 items-center justify-center rounded-2xl bg-white/15 text-3xl sm:flex">
                <i className="ri-chat-smile-3-line"></i>
              </span>
              <div>
                <h2 className="text-xl font-extrabold tracking-tight md:text-2xl">有观点，就别藏着</h2>
                <p className="mt-1.5 max-w-lg text-sm leading-relaxed text-primary-50/90">
                  去热议专区找到你感兴趣的现场，插个嘴、点个赞，和全网瓜友一起围观。
                </p>
              </div>
            </div>
            <Link
              to="/topics"
              className="inline-flex shrink-0 items-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-cream-100 whitespace-nowrap"
            >
              前往热议专区 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>

        <BrandBand />
        <Faqs />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}